module.exports = __webpack_public_path__ + "img/pending_zone.1f79f836.svg";